var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHardware = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-539 -1492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.287,12.811h6.939V5.873H5.287ZM6.346,6.932h4.82v4.819H6.346Z",
    transform: "translate(539.243 1492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,3.875V2.815H15.489V0H14.4V2.815H11.413V0H10.323V2.815H7.42V0H6.331V2.815H3.468V0H2.379V2.815H0v1.06H2.379V6.66H0V7.72H2.379v2.824H0V11.6H2.379V14.51H0v1.06H2.379v2.394H3.468V15.676H6.331V18H7.42V15.676h2.9V18h1.089V15.676H14.4v2.288h1.089V15.57H18V14.51H15.489V11.6H18v-1.06H15.489V7.72H18V6.66H15.489V3.875Zm-14.532,0H14.4V14.616H3.468Z",
    transform: "translate(539 1492)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHardware);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hardware.3ee11da8a639187ee0673edb7191d3e9.svg";